export default function(){
(function($) {
    /*
        Author: Tomas Gerzicak
        Version: 1.0
        Description:
    */

    /**
     * Animate every link that goes to some anchor
     */

    $(function() {
        $("a[href*=\\#]:not([href=\\#])").click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) { $('html,body').animate({
                    scrollTop: target.offset().top - 100 }, 700);
                    return false;
                }
            }
        });



        document.addEventListener('DOMContentLoaded', function () {
            BackgroundCheck.init({
                targets: '.nav__logo'
            });
        });

        function elementExist(selector){
            return $(selector).length > 0;
        }

        var menuOpened = false;



    });



// ************************************
// ****** Small jQuery functions ******
// ************************************

    /**
     *
     * @param selector Query selector
     * @returns {boolean} if element exists
     */
    function elementExist(selector){
        return $(selector).length > 0;
    }

    /**
     * Checks if element has children
     * @returns {boolean}
     */
    function hasChildren() {
        return this.children().length > 0;
    }

    /**
     *
     * @param selector Query selector on element to be scrolled to
     * @param {number} offset (optional) Offset from the element. Default value is 100
     * @param {number} duration (optional) determines, how long will animation lasts
     */
    function smoothScrollTo(selector, offset, duration)
    {
        var target = $(selector);
        $("body, html").animate({
            scrollTop: target.offset().top - offset
        }, duration);
    }


    // function setCookie(cname, cvalue, exdays) {
    //     var d = new Date();
    //     d.setTime(d.getTime() + (exdays*24*60*60*1000));
    //     var expires = "expires="+ d.toUTCString();
    //     document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    // }
    //
    // function getCookie(cname) {
    //     var name = cname + "=";
    //     var decodedCookie = decodeURIComponent(document.cookie);
    //     var ca = decodedCookie.split(';');
    //     for(var i = 0; i <ca.length; i++) {
    //         var c = ca[i];
    //         while (c.charAt(0) == ' ') {
    //             c = c.substring(1);
    //         }
    //         if (c.indexOf(name) == 0) {
    //             return c.substring(name.length, c.length);
    //         }
    //     }
    //     return "";
    // }

    $(function() {
        // $("#cookie-accept").on("click", function () {
        //     setCookie("cookie", "1", 365);
        //     $("#cookie").removeClass("cookie-agreed");
        // })
        // $(document).ready(function () {
        //     var acookie = getCookie("cookie");
        //     if (!acookie) {
        //         $("#cookie").addClass("cookie-agreed");
        //     } else {
        //         $("#cookie").removeClass("cookie-agreed");
        //
        //     }
        // })
    })

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
// We listen to the resize event
    window.addEventListener('resize', () => {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });


})(jQuery);
}
